import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SickLeaveListService } from '../services/sick-leave-list.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-correction',
  templateUrl: './correction.component.html',
  styleUrls: ['./correction.component.css']
})
export class CorrectionComponent implements OnInit {

  public startDateOfLeave: any;
  public correctionForm: FormGroup;
  public errorFlag: boolean;
  public errorMsg: string;
  public formError;
  public config: Partial<BsDatepickerConfig>;

  public closeCorrectionView = {
    closeFlag: false,
    closeMsg: 'cancel'
  };
  @Input('dataObject') dataObject;
  @Input() sickLeave;
  @Output() closeCorrectionViewEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor(public sickLeaveService: SickLeaveListService, public router: Router, public activatedRoute: ActivatedRoute) {
    this.config = Object.assign(
      {},
      {
        containerClass: 'theme-red',
        showWeekNumbers: false,
        dateInputFormat: 'DD/MM/YYYY'
      }
    );
  }

  ngOnInit() {
    this.formError = {
      'employeeId': {
        'required': 'EmployeeId is Required',
        'minlength': 'EmployeeId should contain atleast 3 characters.'
      },
      'fromDate': {
        'required': 'Start date is Required!',
        'minlength': 'Start date is Required!'
      },
      'toDate': {
        'required': 'End date is Required!',
        'minlength': 'Start date is Required!'
      },
      'ocrcertdate': {
        'required': 'Certificate date is Required!',
        'minlength': 'Start date is Required!'
      }
    };

    this.errorFlag = false;
    this.errorMsg = '';
    this.closeCorrectionView.closeFlag = false;

    let ocrstartdate;
    let ocrenddate;
    let ocrcertdate;

    if (this.sickLeave.ocrstartdate === null) {
      ocrstartdate = new Date(new Date().getFullYear(), 0, 1);
    } else {
      ocrstartdate = new Date(this.sickLeave.ocrstartdate);
    }
    this.startDateOfLeave = new Date(ocrstartdate);
    if (this.sickLeave.ocrenddate === null) {
      ocrenddate = new Date(new Date().getFullYear(), 0, 1);
    } else {
      ocrenddate = new Date(this.sickLeave.ocrenddate);
    }
    if (this.sickLeave.ocrcertdate === null) {
      ocrcertdate = new Date(new Date().getFullYear(), 0, 1);
    } else {
      ocrcertdate = new Date(this.sickLeave.ocrcertdate);
    }

    if (this.sickLeave.datesmismatch === null) {
      this.sickLeave.datesmismatch = false;
    }
    if (this.sickLeave.isreasonverified === null) {
      this.sickLeave.isreasonverified = true;
    }
    if (this.sickLeave.potentialphotocopy === null) {
      this.sickLeave.potentialphotocopy = false;
    }
    if (this.sickLeave.signatureseenbefore === null) {
      this.sickLeave.signatureseenbefore = true;
    }
    // if (this.sickLeave.doctorsseen === null) {
    //   this.sickLeave.doctorsseen = 2
    // }
    if (this.sickLeave.sameasrejectedholiday === null) {
      this.sickLeave.sameasrejectedholiday = false;
    }
    if (this.sickLeave.coincideswithmajorevnt === null) {
      this.sickLeave.coincideswithmajorevnt = false;
    }
    if (this.sickLeave.signaturedectected === null) {
      this.sickLeave.signaturedectected = true;
    }
    if (this.sickLeave.iscertvalid === null) {
      this.sickLeave.iscertvalid = true;
    }
    if (this.sickLeave.noocr_date === null) {
      this.sickLeave.noocr_date = false;
    }
    if (this.sickLeave.nocertificate === null) {
      this.sickLeave.nocertificate = false;
    }

    this.correctionForm = new FormGroup({
      employeeId: new FormControl({ value: this.sickLeave.empid, disabled: true }, [Validators.required, Validators.minLength(3)]),
      fromDate: new FormControl(ocrstartdate, [Validators.required, Validators.minLength(1)]),
      toDate: new FormControl(ocrenddate, [Validators.required, Validators.minLength(1)]),
      ocrcertdate: new FormControl(ocrcertdate, [Validators.required, Validators.minLength(1)]),

      datesmismatch: new FormControl(this.sickLeave.datesmismatch),
      isreasonverified: new FormControl(!this.sickLeave.isreasonverified),
      potentialphotocopy: new FormControl(this.sickLeave.potentialphotocopy),
      signatureseenbefore: new FormControl(!this.sickLeave.signatureseenbefore),
      // doctorsseen: new FormControl(this.sickLeave.doctorsseen >= 3 ? true : false),
      sameasrejectedholiday: new FormControl(this.sickLeave.sameasrejectedholiday),
      coincideswithmajorevnt: new FormControl(this.sickLeave.coincideswithmajorevnt),
      signaturedectected: new FormControl(!this.sickLeave.signaturedectected),
      iscertvalid: new FormControl(!this.sickLeave.iscertvalid),
      noocrdate: new FormControl(this.sickLeave.noocr_date),
      nocertificate: new FormControl(this.sickLeave.nocertificate),
      comments: new FormControl('')
    });
  }

  dateTransform(date: Date) {
    const temp = date

    const day = temp.getDate();
    const month = temp.getMonth() + 1;
    const year = temp.getFullYear();
    return month.toString() + '/' + day.toString() + '/' + year.toString();
    // return temp;
  }

  correctionFormClose() {
    this.closeCorrectionView.closeFlag = true;
    this.closeCorrectionView.closeMsg = 'cancel';
    this.closeCorrectionViewEvent.emit(this.closeCorrectionView);
  }

  dateTransformReverse(date: Date) {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return year.toString() + "-" + month.toString() + "-" + day.toString();
  }

  correctionFormSubmit(correctionForm) {
    this.errorFlag = false;
    this.errorMsg = '';
    if (this.correctionForm.invalid) {
      return;
    }

    const correctedDetails = {
      absenceid: this.sickLeave.absenceid,
      revisionkey: this.sickLeave.revisionkey,
      recordcreatedby: sessionStorage.getItem('user'),
      manuallycorrctd: true,
      coincideswithmajorevnt: this.sickLeave.coincideswithmajorevnt,
      datesmismatch: this.sickLeave.datesmismatch,
      // doctorsseen: correctionForm.doctorsseen ? 4 : 2,
      iscertvalid: this.sickLeave.iscertvalid,
      isreasonverified: this.sickLeave.isreasonverified,
      potentialphotocopy: this.sickLeave.potentialphotocopy,
      sameasrejectedholiday: this.sickLeave.sameasrejectedholiday,
      signaturedectected: this.sickLeave.signaturedectected,
      signatureseenbefore: this.sickLeave.signatureseenbefore,
      noocrdate: this.sickLeave.noocr_date,
      nocertificate: this.sickLeave.nocertificate,
      ocrcertdate: this.dateTransformReverse(correctionForm.ocrcertdate),
      ocrstartdate: this.dateTransformReverse(correctionForm.fromDate),
      ocrenddate: this.dateTransformReverse(correctionForm.toDate),
      commentscorrection: correctionForm.comments
    };


    this.errorFlag = false;
    let ids = [];
    ids.push(correctedDetails);

    const dates = {
      startDate: this.dateTransform(correctionForm.fromDate),
      endDate: this.dateTransform(correctionForm.toDate)
    }

    if (new Date(dates.startDate) > new Date(dates.endDate)) {
      this.errorFlag = true;
      this.errorMsg = 'Start date could not be after End date!';
      return;
    }

    this.sickLeaveService.updateHrExpertAllocation(ids, [], sessionStorage.getItem('user'))
      .subscribe(
        (res) => {
          if (res.status === 'success') {
            alert('Correction successful!');
            // this.router.navigate(['/sll']);
            this.closeCorrectionView.closeFlag = true;
            this.closeCorrectionView.closeMsg = 'submit';
            this.closeCorrectionViewEvent.emit(this.closeCorrectionView);
          } else {
            if (res.status === 'fail') {
              alert('Error while correction!');
            }
          }
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveService.redirectToSAB();
          }
        }
      );

  }

}



// WEBPACK FOOTER //
// ./src/app/correction/correction.component.ts